import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SingleCause } from "../Causes/SingleCause";
import { SingleEvaluation } from "./SingleEvaluation";
import Icon from "../../../../Icon/Icon";
import { isPago } from "../../../../../helpers/getLogo";

// Evaluacion solo para la vista
export const EvaluationsView = ({
  evaluations,
  causes,
  justView,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  return (
    <Stack padding={justView ? 0 : 2} spacing={2}>

      {
        evaluations.policies.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.policies}
          justView={justView}
          itemTitle={t("evaluation.policies_item_title")}
          color="#55E5B8"
          itemIcon="bold_security_danger"
          evaluationType="policies"
        />
      }
      
      {
        evaluations.measures.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.measures}
          justView={justView}
          itemTitle={t("evaluation.measures_item_title")}
          color="#7BBDFF"
          itemIcon="bold_additem"
        />
      }

      {
        evaluations.actions.list.length > 0 &&
        <SingleEvaluation
          evaluation={evaluations.actions}
          justView={justView}
          itemTitle={t("evaluation.actions_item_title")}
          color="#F4996C"
          itemIcon="bold_security_danger"
          evaluationType="actions"
        />
      }

      {
        causes.length > 0 &&
        causes.map((cause, idx) => (
          <SingleCause
            key={idx}
            cause={cause}
          />
        ))
      }

      {
        !isPago() && evaluations.karin_law?.active && (
          <Box
            sx={{
              backgroundColor: theme.palette.purple?.light || "#E8D5F2",
              borderRadius: 2,
              padding: 2,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1} mb={1}>
              <Icon name="bold_security_danger" color={theme.palette.purple?.main || "#9C27B0"} size={20} />
              <Typography fontWeight={600} color={theme.palette.purple?.main || "#9C27B0"}>
                {t("evaluation.karin_law_title")}
              </Typography>
            </Stack>
            {evaluations.karin_law.details && (
              <Typography color="secondary" sx={{ ml: 3.5 }}>
                {evaluations.karin_law.details}
              </Typography>
            )}
          </Box>
        )
      }

    </Stack>
  )
}